/**
 * DateSocialShareEdit — modo de edição do bloco DateSocialShare.
 */
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import { SidebarPortal } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import DateSocialShareSchema from './schema';
import DateSocialShareView from './DateSocialShareView';

const DateSocialShareEdit = (props: any) => {
  const { data, onChangeBlock, block, selected, properties } = props;
  const intl = useIntl();
  const schema = DateSocialShareSchema(intl);

  return (
    <>
      <DateSocialShareView data={data} properties={properties} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: any) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default DateSocialShareEdit;
